import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ui-components/components/modal';
import style from '../../style.module.less';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';

const DeleteShipperHQConnectionModal = ({ onClose, onDelete }) => {
  return (
    <Modal className={style['shipperHQ-modal-base']} size='custom'>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...messages.deleteConnection} />
      </ModalHeader>
      <ModalBody className={style['shipperHQ-modal-body']}>
        <div className={style.warning}>
          <FormattedMessage {...messages.deleteConnectionWarning} />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className={style['delete-footer-buttons']}>
          <Button onClick={onClose}>
            <FormattedMessage {...messages.cancel} />
          </Button>
          <Button onClick={onDelete} theme='danger'>
            <FormattedMessage {...messages.delete} />
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

DeleteShipperHQConnectionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteShipperHQConnectionModal;
